import { getAllPositionsByDepartmentId } from '@/modules/Employee/services'
import { useQuery } from '@tanstack/react-query'
import { FieldValues, Path, UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import { FilterSelect } from '@/components/ui/filters'

interface PositionSelectProps<T extends FieldValues> {
    departmentId: number
    name: Path<T>
    control: UseFormReturn<T, any, any>['control']
    onChangeAfterHookForm?: (value?: any) => void
}

const PositionSelect = <T extends FieldValues>({
    departmentId,
    control,
    name,
    onChangeAfterHookForm,
}: PositionSelectProps<T>) => {
    const { data: positions, isFetching: isFetchingPositions } = useQuery({
        queryKey: [QUERY_KEYS.POSITIONS, departmentId],
        queryFn: () => getAllPositionsByDepartmentId(departmentId),
        enabled: !!departmentId,
    })

    const { t } = useTranslation()

    const options =
        positions?.results?.map((item) => ({
            label: item.position_name,
            value: item.position_id,
        })) || []

    return (
        <FilterSelect
            control={control}
            name={name}
            label={t('position')}
            placeholder={t('position_placeholder')}
            options={options}
            disabled={!departmentId || isFetchingPositions}
            showClearButton={false}
            onChangeAfterHookForm={onChangeAfterHookForm}
        />
    )
}

export default PositionSelect
